import { Box, Typography, Grid } from '@mui/material';

import { FBoxContainer, FHSkeletonLoader } from '../../../../components/base';
import { useProviderDetailsState } from '../hooks';
import { BASIC_INFO_ROW_SX } from '../styles';

export function ProviderBasicInfo() {
  const { provider, loading } = useProviderDetailsState();

  return (
    <FBoxContainer sx={{ height: '100%' }}>
      {loading ? (
        <>
          <FHSkeletonLoader height={30} width={110} sx={{ mb: 0.5 }} />
          <FHSkeletonLoader
            rowCount={5}
            height={20}
            sx={{ mt: 2 }}
            containerStyles={{ mt: 1 }}
            width={250}
          />
        </>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          <Typography variant="h6" mb={2}>
            Basic Info
          </Typography>
          <Grid container p={1} sx={BASIC_INFO_ROW_SX}>
            <Grid item xs={5}>
              <Typography>Name:</Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography>
                {provider?.first_name} {provider?.last_name}
              </Typography>
            </Grid>
          </Grid>
          <Grid container p={1} sx={BASIC_INFO_ROW_SX}>
            <Grid item xs={5}>
              <Typography>Provider Id:</Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography>{provider?.id}</Typography>
            </Grid>
          </Grid>
          <Grid container p={1} sx={BASIC_INFO_ROW_SX}>
            <Grid item xs={5}>
              <Typography>Email:</Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography style={{ wordWrap: 'break-word' }}>{provider?.email}</Typography>
            </Grid>
          </Grid>
          <Grid container p={1} sx={BASIC_INFO_ROW_SX}>
            <Grid item xs={5}>
              <Typography>Phone:</Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography>{provider?.phone}</Typography>
            </Grid>
          </Grid>
          <Grid container p={1} sx={BASIC_INFO_ROW_SX}>
            <Grid item xs={5}>
              <Typography>Gender:</Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography>{provider?.sex}</Typography>
            </Grid>
          </Grid>
        </Box>
      )}
    </FBoxContainer>
  );
}
